import React, { Component } from 'react';
import Slider from 'rc-slider';


class DataSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.threshold,
      min: 0,
      max: 50
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.threshold !== this.props.threshold) {
      this.setState({
        value: this.props.threshold
      });
    }
  }

  handleChange = e => {
    this.setState({ value: e });
  };

  handleAfterChange = e => {
    this.props.changeThreshold(e);
  };

  decrease = () => {
    let value = this.state.value - 1;
    if (value < this.state.min) {
      return false;
    }

    this.setState({ value });
    this.handleAfterChange(value);
  };

  increase = () => {
    let value = this.state.value + 1;
    if (value > this.state.max) {
      return false;
    }

    this.setState({ value });
    this.handleAfterChange(value);
  };

  render() {
    return (
      <div className="data-slider" style={{ padding: '0px 15px 1px 40px' }}>
        <div className="data-slider-container">
          <button
            className="btn btn-default btn-white-shadow"
            disabled={this.state.value === this.state.min}
            onClick={this.decrease}
          >
            <i className="fa fa-chevron-left glyphicon glyphicon-chevron-left"></i>
          </button>
          <Slider
            min={this.state.min}
            max={this.state.max}
            value={this.state.value}
            onChange={this.handleChange}
            onAfterChange={this.handleAfterChange}
          />
          <button
            className="btn btn-default btn-white-shadow"
            disabled={this.state.value === this.state.max}
            onClick={this.increase}
          >
            <i className="fa fa-chevron-right glyphicon glyphicon-chevron-right"></i>
          </button>
        </div>
        <p className="data-lbl">
          {this.state.value} %
        </p>
      </div>
    );
  }
}

export default DataSlider;
